import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from '../../constants'

// constants
export const AUDIT_FETCH_LIST = 'audit/FETCH_LIST'
export const AUDIT_FETCH_TABLE = 'audit/FETCH_TABLE'
export const AUDIT_FETCH_TABLE_FILTERS = 'audit/FETCH_TABLE_FILTERS'
export const AUDIT_SET_TABLE = 'audit/SET_TABLE'
export const AUDIT_SET_TABLE_FILTERS = 'audit/FETCH_SET_FILTERS'
export const AUDIT_CLEAR_STATE = 'audit/CLEAR_STATE'
export const [AUDIT_FETCH_LIST_SUCCESS, AUDIT_FETCH_LIST_FAILURE] = [
  `${AUDIT_FETCH_LIST}_SUCCESS`,
  `${AUDIT_FETCH_LIST}_FAILURE`,
]

// actions
export const auditFetchTable = ActionHelper.createActionObj(AUDIT_FETCH_TABLE)
export const auditFetchTableFilters = ActionHelper.createActionObj(
  AUDIT_FETCH_TABLE_FILTERS,
)
export const auditClearStateList = ActionHelper.createActionObj(
  AUDIT_CLEAR_STATE,
)

// state
const initialState = fromJS({
  tableFilters: [],
  tableData: {
    data: [],
    count: 0,
  },
})

// reducers
const audit = handleActions(
  {
    [AUDIT_FETCH_LIST_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.tableData)),

    [AUDIT_SET_TABLE]: (state, action) =>
      state.set('tableData', Map(action.tableData)),
    [AUDIT_SET_TABLE_FILTERS]: (state, action) =>
      state.set('tableFilters', List(action.tableFilters)),

    [AUDIT_CLEAR_STATE]: () => initialState,
    [RESET_STORE]: () => initialState,
  },
  initialState,
)

export default audit
